import React, { Component } from "react"
import { Col, Row, Card, Modal } from "react-bootstrap"

import {
  CustomCheckbox,
  BottomsheetDropdown,
} from "../../../../../../../components"
import { InfoCircleIcon } from "constants/Images"

import "./additional-cards.css"
import { observer } from "mobx-react"
import UiButton from "components/ui/button/Button"

class AdditionalCards extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isAdditionalBenefitModalOpen: false,
      modalTitle: "",
      modalDescription: "",
    }
  }

  showBenefitModal = (title, description) => {
    this.setState({
      isAdditionalBenefitModalOpen: true,
      modalTitle: title,
      modalDescription: description,
    })
  }

  hideBenefitModal = () => {
    this.setState({ isAdditionalBenefitModalOpen: false })
  }

  render() {
    const { form, data } = this.props

    let maritalStatus = form.$("marital-status").value.id
    let betterHalfBenefit = form.$("better-half-benefit").disabled 
    // console.log("maritalStatus>>>>>" , maritalStatus , betterHalfBenefit)
    return (
      <>
        <div className="additional-cards">
          <p className="mb-2 pb-1 font-size-14 font-weight-medium text-dark-grey">
            Additional Benefits
          </p>
          <Card className="border">
            <Card.Body>
              {/* 1st */}
              { ( Number(maritalStatus) ===  2  || !betterHalfBenefit) && (
                <Row
                  // className={` ${form.$("better-half-benefit").disabled ? "" : ""
                  //   }`}
                >
                  <Col className="col-9">
                    <div className="d-flex align-items-center">
                      <CustomCheckbox
                        shape="rounded"
                        title={form.$("better-half-benefit").label}
                        titleStyle="font-weight-medium font-size-14 pl-2 additional-benefits-cards-text"
                        isChecked={form.$("better-half-benefit").value}
                        onChange={() =>
                          form
                            .$("better-half-benefit")
                            .extra.changeBenefitStatus(form, data)
                        }
                        // onHover={() =>
                        //   this.showBenefitModal(
                        //     form.$("better-half-benefit").label,
                        //     form.$("better-half-benefit").extra.description
                        //   )}
                        mark="checkmark"
                      />
                      <img
                        className={`pl-2 ${form.$("better-half-benefit").disabled
                          ? "inf0-icon-disable"
                          : ""
                          }`}
                        src={InfoCircleIcon}
                        alt="info"
                        onMouseOver={() =>
                          this.showBenefitModal(
                            form.$("better-half-benefit").label,
                            form.$("better-half-benefit").extra.description
                          )
                        }
                      />
                    </div>
                    <p className="font-weight-300 pl-3 ml-4 font-size-14 description-text-color">Additional safety for family in case of primary earner's death</p>
                  </Col>
                  <Col className="align-items-center col-3 col-border-left d-flex flex-column justify-content-center col-line-height">
                    {data?.data?.firstYearResponse?.BHB_MODAL_PREM ? (
                      <React.Fragment>
                        <div className="d-flex justify-content-end">
                          <p className="mb-0 font-weight-300 font-size-20 benefits-premium">
                            {" "}
                            {global.toINR(data?.data?.firstYearResponse?.BHB_MODAL_PREM)}
                          </p>
                        </div>
                      </React.Fragment>
                    ) : null}
                  </Col>
                </Row>
              )}
              <Row
                className={`mt-3 ${form.$("childs-future-protect-benefit").disabled ? "disable-card" : ""
                  }`}
              >
                <Col className="col-9">
                  <div className="d-flex align-items-center">
                    <CustomCheckbox
                      shape="rounded"
                      title={form.$("childs-future-protect-benefit").label}
                      titleStyle="font-weight-medium font-size-14 pl-2 additional-benefits-cards-text"
                      isChecked={form.$("childs-future-protect-benefit").value}
                      onChange={() =>
                        form
                          .$("childs-future-protect-benefit")
                          .extra.onChangechildBenefit(form, data)
                      }
                      // onHover={() =>
                      //   this.showBenefitModal(
                      //     form.$("childs-future-protect-benefit").label,
                      //     form.$("childs-future-protect-benefit").extra.description
                      //   )}
                      mark="checkmark"
                    />
                    <img
                      className={`pl-2 ${form.$("childs-future-protect-benefit").disabled
                        ? "inf0-icon-disable"
                        : ""
                        }`}
                      src={InfoCircleIcon}
                      alt="info"
                      onMouseOver={() =>
                        this.showBenefitModal(
                          form.$("childs-future-protect-benefit").label,
                          form.$("childs-future-protect-benefit").extra.description
                        )
                      }
                    />
                  </div>
                  <p className="font-weight-300 pl-3 ml-4 font-size-14 description-text-color">Higher life cover to manage higher liabilities till children become independent</p>
                </Col>

                {/* <Col className="col-9">
                  <div className="d-flex align-items-center">
                    <CustomCheckbox
                      shape="rounded"
                      title={form.$("premium-breaks").label}
                      titleStyle="font-weight-medium font-size-14 pl-2 additional-benefits-cards-text"
                      isChecked={form.$("premium-breaks").value}
                      onChange={() =>
                        form
                          .$("premium-breaks")
                          .extra.onChangePremiumBreakStatus(form, data)
                      }
                      // onHover={() =>
                      //   this.showBenefitModal(
                      //     form.$("premium-breaks").label,
                      //     form.$("premium-breaks").extra.description
                      //   )}
                      mark="checkmark"
                    />
                    <img
                      className={`pl-2 ${form.$("premium-breaks").disabled
                        ? "inf0-icon-disable"
                        : ""
                        }`}
                      src={InfoCircleIcon}
                      alt="info"
                      onMouseOver={() =>
                        this.showBenefitModal(
                          form.$("premium-breaks").label,
                          form.$("premium-breaks").extra.description
                        )
                      }
                    />
                  </div>
                  <p className="font-weight-300 pl-3 ml-4 font-size-14 description-text-color">Higher Premium Breaks</p>
                </Col> */}

                <Col className="align-items-center col-3 col-border-left d-flex flex-column justify-content-center col-line-height">
                  {data?.data?.firstYearResponse?.CHILD_MODAL_PREM ? (
                    <React.Fragment>
                      <div className="d-flex justify-content-end">
                        <p className="mb-0 font-weight-300 font-size-20 benefits-premium">
                          {" "}
                          {global.toINR(data?.data?.firstYearResponse?.CHILD_MODAL_PREM)}
                        </p>
                      </div>
                    </React.Fragment>
                  ) : null}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>

        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          className="rider-info-modal"
          show={this.state.isAdditionalBenefitModalOpen}
          keyboard={false}
        >
          <Modal.Body className="text-center text-primary-title-label-color px-4 pt-4 pb-0">
            <React.Fragment>
              <h3 className="font-weight-medium font-size-22 font-size-md-32 mb-3">
                {this.state.modalTitle}
              </h3>
              <p className="font-weight-normal font-size-20 font-size-md-20 mb-0">
                {this.state.modalDescription}
              </p>
            </React.Fragment>
          </Modal.Body>
          <Modal.Footer className="d-block p-4 border-0">
            <Row className="modal-footer-row">
              <React.Fragment>
                <Col xs="12">
                  <UiButton
                    onClick={this.hideBenefitModal}
                    className="font-size-medium font-size-16 px-2 w-100 mb-2 mb-md-0"
                    variant="secondary"
                    buttonText="OKAY"
                  />
                </Col>
              </React.Fragment>
            </Row>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}

export default observer(AdditionalCards)
